import React, {useState} from "react";
import classNames from "classnames";
import FieldLabel from "../base/FieldLabel";
import Input from "../base/Input";

const ShowPasswordButton = (props) => {
  const {showPassword, toggleShowPassword, dataAutomationId, valid} = props;
  return (
    <label // eslint-disable-line
      style={{marginLeft: !valid ? -74 : -48}}
      id="showPasswordCheck"
      className="u__text--alternate show-pass-transition"
      onClick={toggleShowPassword}
      data-automation-id={`${dataAutomationId}_ShowPasswordButton`}
    >
      {showPassword ? "Hide" : "Show"}
    </label>
  );
};

const PasswordField = React.forwardRef((props, ref) => {
  const {
    className,
    children,
    valid,
    dataAutomationId,
  } = props;

  const inputClass = classNames("form-input", {
    "form-input--error": !valid
  });
  const [showPass, setShowPass] = useState(false);
  const toggleShowPass = ()=> setShowPass(!showPass);
  const type = showPass? "text" : "password";

  return (
    <div className={`${inputClass} ${className || ""}`}>
      <FieldLabel {...props} />
      <span className={"u__flex"}>
        <Input {...props} type={type} ref={ref} />
        <ShowPasswordButton
          valid={valid}
          showPassword={showPass}
          toggleShowPassword={toggleShowPass}
          dataAutomationId={dataAutomationId} />
      </span>
      <React.Fragment>
        {children}
      </React.Fragment>
    </div>
  );
});

PasswordField.displayName = "PasswordField";

export default PasswordField;
